// src/components/ServiceProfile/ServiceProfile.js
import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import ProfileData from './ProfileData';
import './ServiceProfile.css';
import translations from '../../lang'; // Nyelvi fordítások importálása

const ServiceProfile = () => {
    const language = localStorage.getItem('language') || 'ro';
    const t = translations[language];

    return (
        <div className="service-profile">
            <nav className="profile-nav">
                <NavLink 
                    to="profiledata" 
                    className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
                >
                    {t.profile_data}
                </NavLink>
            </nav>
            <div className="profile-content">
                <Routes>
                    <Route path="/" element={<ProfileData />} />
                    <Route path="profiledata" element={<ProfileData />} />
                </Routes>
            </div>
        </div>
    );
};

export default ServiceProfile;
